/** Gauss/Meeus algorithm for the date of Easter Sunday. */
export function getEasterDate(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const p = h + l - 7 * m + 114;
  const month = Math.floor(p / 31) - 1;
  const day = (p % 31) + 1;
  return new Date(year, month, day);
}

export function isPolishHoliday(date: Date): boolean {
  const d = date.getDate();
  const m = date.getMonth();
  const y = date.getFullYear();
  const fixedHolidays = ['0-1', '0-6', '4-1', '4-3', '7-15', '10-1', '10-11', '11-24', '11-25', '11-26'];
  if (fixedHolidays.includes(`${m}-${d}`)) return true;

  const easter = getEasterDate(y);
  const easterMonday = new Date(easter.getTime());
  easterMonday.setDate(easter.getDate() + 1);
  const corpusChristi = new Date(easter.getTime());
  corpusChristi.setDate(easter.getDate() + 60);

  const isSameDay = (d1: Date, d2: Date) => d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth();
  return isSameDay(date, easter) || isSameDay(date, easterMonday) || isSameDay(date, corpusChristi);
}

export function addBusinessDays(startDate: Date, daysToAdd: number): Date {
  const currentDate = new Date(startDate.getTime());
  let addedDays = 0;
  while (addedDays < daysToAdd) {
    currentDate.setDate(currentDate.getDate() + 1);
    const dayOfWeek = currentDate.getDay();
    if (dayOfWeek !== 6 && dayOfWeek !== 0 && !isPolishHoliday(currentDate)) addedDays++;
  }
  return currentDate;
}

function toISODate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Earliest allowed pickup date (3 business days ahead) in YYYY-MM-DD format. */
export function getMinDateISO(): string {
  return toISODate(addBusinessDays(new Date(), 3));
}

/** Latest allowed pickup date (15 months ahead) in YYYY-MM-DD format. */
export function getMaxDateISO(): string {
  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 15);
  return toISODate(maxDate);
}
